import { t } from 'i18next';

export const RelatedCategoricalGroup2GoodsUnionPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: t('directory.categoricalGroup.RelatedCategoricalGroup2GoodsUnionPluginSettings.gridPluginName'),
        mnemocode: "related_categorical_group_2Goods_union_plugin",
        permission: "CategoricalGroup",
        columns: [
             {
                order: index++,
                propertyName: "idGlobal",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.RelatedCategoricalGroup2GoodsUnionPluginSettings.idGlobal'),
                visibility: false,
                width: 160,
            },
            {
                order: index++,
                propertyName: "goodsCode",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.RelatedCategoricalGroup2GoodsUnionPluginSettings.goodsCode'),
                visibility: true,
                width: 160,
            },
            {
                order: index++,
                propertyName: "goodsName",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.RelatedCategoricalGroup2GoodsUnionPluginSettings.goodsName'),
                visibility: true,
                width: 360,
            },
        ],
    }
};
